import { useState, useEffect } from 'react'

const useIsRTL = () => {
  const [isRTL, setIsRTL] = useState(() => {
    const dir = document.documentElement.dir || document.body.dir
    return dir.toLowerCase() === 'rtl'
  })

  useEffect(() => {
    const checkRTL = () => {
      const dir = document.documentElement.dir || document.body.dir
      setIsRTL(dir.toLowerCase() === 'rtl')
    }

    // Vérifier initialement
    checkRTL()

    // Observer les changements de l'attribut dir
    const observer = new MutationObserver(checkRTL)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['dir'],
    })

    // Nettoyer l'observateur lors du démontage
    return () => observer.disconnect()
  }, [])

  return isRTL
}

export default useIsRTL
